<template>
  <div class="messageList">
    <el-button size="mini" @click="showDialog" type="primary"
      >新增消息</el-button
    >
    <el-collapse style="margin-top: 30px" accordion>
      <el-collapse-item name="1">
        <template slot="title">
          一致性 Consistency
          <!-- <i
            @click.stop="removeMessage()"
            class="header-icon el-icon-delete"
          ></i> -->
        </template>
        <div>
          与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <el-form :model="addFrom" class="demo-form-inline">
        <el-form-item label="标题：">
          <el-input v-model="addFrom.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="内容：">
          <el-input
            v-model="addFrom.message"
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="接受人：">
          <el-select v-model="addFrom.recivedUId" multiple placeholder="请选择">
            <el-option
              v-for="item in users"
              :key="item.uID"
              :label="item.uRealName"
              :value="item.uID"
            >
            </el-option>
          </el-select>
          <span style="padding-left: 10px">是否全选：</span>
          <el-switch @change="checkAllFn" v-model="isCheckAll"> </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AddBatchMessage">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserListPage, AddBatchMessage } from "@/api/api";
export default {
  data() {
    return {
      dialogVisible: false,
      addFrom: {
        type: 1,
        recivedUId: [],
        title: "",
        message: "",
      },
      users: [],
      userInfo: {},
      isCheckAll: false,
    };
  },
  created() {
    this.userInfo = JSON.parse(
      window.localStorage.user ? window.localStorage.user : null
    );
    this.getUsers();
  },
  methods: {
    //   添加
    async AddBatchMessage() {
      //console.log(this.addFrom);
      if (this.addFrom.title.length == 0) {
        this.$message.warning("请输入标题");
        return;
      }
      if (this.addFrom.message.length == 0) {
        this.$message.warning("请输入内容");
        return;
      }
      if (this.addFrom.recivedUId.length == 0) {
        this.$message.warning("请选择接收人");
        return;
      }
      let xhr = await AddBatchMessage(this.addFrom);
      if (xhr.data.success) {
        this.$message.success("发送成功");
        this.dialogVisible = false;
      } else {
        this.$message.success(xhr.data.msg);
      }
    },
    removeMessage() {},
    GetNoticeByPage() {},
    showDialog() {
      this.addFrom.message = "";
      this.addFrom.recivedUId = [];
      this.addFrom.title = "";
      this.dialogVisible = true;
    },
    checkAllFn(e) {
      ;
      this.addFrom.recivedUId = [];
      if (e) {
        this.users.forEach((item) => {
          this.addFrom.recivedUId.push(item.uID);
        });
      }
    },
    //获取用户列表
    getUsers() {
      let para = {
        PageIndex: 1,
        PageSize: 999999,
        key: "",
        uid: this.userInfo.uID,
        Phone: "",
        identity: -1,
      };
      getUserListPage(para).then((res) => {
        this.users = res.data.response.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  border-radius: 10px;
  overflow: hidden;
}
.messageList {
  background-color: #ffffff;
  padding-top: 10px;
  padding-left: 10px;
}
.header-icon {
  color: red;
  padding-left: 10px;
}
</style>